import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { Event$, TrackLevel_$reflection, Task_$reflection, Course_$reflection, Track_$reflection, Event$_$reflection } from "../Shared/SharedModels.jsx";
import { union_type, int32_type, string_type, record_type, bool_type, option_type, array_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { toArray, bind, defaultArg, map } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { sortBy, contains, tryPick, tryFind, append, map as map_1 } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { int32ToString, createObj, numberHash, safeHash, equals } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { startAsPromise } from "../fable_modules/fable-library-js.4.24.0/Async.js";
import { singleton } from "../fable_modules/fable-library-js.4.24.0/AsyncBuilder.js";
import { toastServerError, Task, Course, Track, Event$ as Event$_1 } from "../ApiClient.jsx";
import { Result_ToOption } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { successToast, errorToast } from "../Toasts.jsx";
import { createElement } from "react";
import React from "react";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { SkeletonItem, Skeleton, Tooltip, Input, Title3, Divider, Checkbox, Body1Strong, PopoverSurface, PopoverTrigger, Popover, CardFooter, Button, Link, Caption2, Label, tokens, Caption1, Badge, Subtitle1, Card } from "@fluentui/react-components";
import { tryHead, iterate, take, length, empty, singleton as singleton_1, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { WeatherSunnyLowRegular, ArrowResetRegular, SearchRegular, FilterRegular, LayerRegular, LayerDiagonalPersonRegular, ArrowRightRegular, LocationRegular, PeopleQueueRegular, ClockRegular, CalendarDateRegular, PersonAccountsRegular, CheckboxCheckedRegular } from "@fluentui/react-icons";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { nb } from "date-fns/locale";
import { format as format_2 } from "date-fns";
import { RouterModule_encodeParts } from "../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { Checkbox_toBool } from "../fable_modules/FS.FluentUI.2.5.2/Domain.fs.js";
import { useCtx } from "../Context.jsx";
import { useEffectOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { Dialog } from "./AddEvent.jsx";
import { compare } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { dataFetchFailedView } from "../Helpers.jsx";

class Model extends Record {
    constructor(Events, AllTracks, AllCourses, IsFetchingEvents, UserCompletedTasks, EventsUserAttends, Filter) {
        super();
        this.Events = Events;
        this.AllTracks = AllTracks;
        this.AllCourses = AllCourses;
        this.IsFetchingEvents = IsFetchingEvents;
        this.UserCompletedTasks = UserCompletedTasks;
        this.EventsUserAttends = EventsUserAttends;
        this.Filter = Filter;
    }
}

function Model_$reflection() {
    return record_type("Event.ListEvents.Model", [], Model, () => [["Events", option_type(array_type(Event$_$reflection()))], ["AllTracks", array_type(Track_$reflection())], ["AllCourses", array_type(Course_$reflection())], ["IsFetchingEvents", bool_type], ["UserCompletedTasks", array_type(Task_$reflection())], ["EventsUserAttends", array_type(Event$_$reflection())], ["Filter", Filter_$reflection()]]);
}

class Filter extends Record {
    constructor(SearchTerm, ShowOnlyEligible, ShowOnlyFromLevels, ShowOnlyOfCourses) {
        super();
        this.SearchTerm = SearchTerm;
        this.ShowOnlyEligible = ShowOnlyEligible;
        this.ShowOnlyFromLevels = ShowOnlyFromLevels;
        this.ShowOnlyOfCourses = ShowOnlyOfCourses;
    }
}

function Filter_$reflection() {
    return record_type("Event.ListEvents.Filter", [], Filter, () => [["SearchTerm", string_type], ["ShowOnlyEligible", bool_type], ["ShowOnlyFromLevels", array_type(TrackLevel_$reflection())], ["ShowOnlyOfCourses", array_type(int32_type)]]);
}

function Filter_Empty() {
    return new Filter("", false, [], new Int32Array([]));
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateEvents", "UpdateAllTracks", "UpdateAllCourses", "SetIsFetching", "UpdateUserCompletedTasks", "UpdateEventsUserAttends", "UpdateFilter", "SignedUpTo", "WithdrewFrom"];
    }
}

function Msg_$reflection() {
    return union_type("Event.ListEvents.Msg", [], Msg, () => [[["Item", option_type(array_type(Event$_$reflection()))]], [["Item", array_type(Track_$reflection())]], [["Item", array_type(Course_$reflection())]], [["Item", bool_type]], [["Item", array_type(Task_$reflection())]], [["Item", array_type(Event$_$reflection())]], [["Item", Filter_$reflection()]], [["Item", int32_type]], [["Item", int32_type]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.Events, msg.fields[0], model.AllCourses, model.IsFetchingEvents, model.UserCompletedTasks, model.EventsUserAttends, model.Filter);
        case 2:
            return new Model(model.Events, model.AllTracks, msg.fields[0], model.IsFetchingEvents, model.UserCompletedTasks, model.EventsUserAttends, model.Filter);
        case 3:
            return new Model(model.Events, model.AllTracks, model.AllCourses, msg.fields[0], model.UserCompletedTasks, model.EventsUserAttends, model.Filter);
        case 4:
            return new Model(model.Events, model.AllTracks, model.AllCourses, model.IsFetchingEvents, msg.fields[0], model.EventsUserAttends, model.Filter);
        case 5:
            return new Model(model.Events, model.AllTracks, model.AllCourses, model.IsFetchingEvents, model.UserCompletedTasks, msg.fields[0], model.Filter);
        case 6:
            return new Model(model.Events, model.AllTracks, model.AllCourses, model.IsFetchingEvents, model.UserCompletedTasks, model.EventsUserAttends, msg.fields[0]);
        case 7: {
            const eventId = msg.fields[0] | 0;
            const newEvents = map((events_2) => map_1((event) => {
                if (event.Id === eventId) {
                    return new Event$(event.Id, event.Name, event.Enabled, event.Summary, event.Description, event.Address, event.MaxAttendees, event.AttendeeCount + 1, event.Time, event.Course, event.Teacher, event.Region);
                }
                else {
                    return event;
                }
            }, events_2), model.Events);
            return new Model(newEvents, model.AllTracks, model.AllCourses, model.IsFetchingEvents, model.UserCompletedTasks, defaultArg(map((event_2) => append([event_2], model.EventsUserAttends), bind((array_1) => tryFind((event_1) => (event_1.Id === eventId), array_1), newEvents)), model.EventsUserAttends), model.Filter);
        }
        case 8: {
            const eventId_1 = msg.fields[0] | 0;
            return new Model(map((events_3) => map_1((event_3) => {
                if (event_3.Id === eventId_1) {
                    return new Event$(event_3.Id, event_3.Name, event_3.Enabled, event_3.Summary, event_3.Description, event_3.Address, event_3.MaxAttendees, event_3.AttendeeCount - 1, event_3.Time, event_3.Course, event_3.Teacher, event_3.Region);
                }
                else {
                    return event_3;
                }
            }, events_3), model.Events), model.AllTracks, model.AllCourses, model.IsFetchingEvents, model.UserCompletedTasks, model.EventsUserAttends.filter((event_4) => (event_4.Id !== eventId_1)), model.Filter);
        }
        default:
            return new Model(msg.fields[0], model.AllTracks, model.AllCourses, model.IsFetchingEvents, model.UserCompletedTasks, model.EventsUserAttends, model.Filter);
    }
}

function init() {
    return new Model(undefined, [], [], true, [], [], Filter_Empty());
}

function applyFilter(model, event) {
    const eventTrackLevel = tryPick((track) => tryFind((level) => level.TrackLevelCourses.some((tlc) => (tlc.Course.Id === event.Course.Id)), track.TrackLevels), model.AllTracks);
    const isEligible = defaultArg(map((level_1) => level_1.RequiredTasks.every((requiredTask) => contains(requiredTask, model.UserCompletedTasks, {
        Equals: equals,
        GetHashCode: safeHash,
    })), eventTrackLevel), true);
    const isInLevelsToShow = defaultArg(map((level_2) => contains(level_2, model.Filter.ShowOnlyFromLevels, {
        Equals: equals,
        GetHashCode: safeHash,
    }), eventTrackLevel), true);
    const isOneOfCoursesToShow = contains(event.Course.Id, model.Filter.ShowOnlyOfCourses, {
        Equals: (x_2, y_2) => (x_2 === y_2),
        GetHashCode: numberHash,
    });
    const searchTerm = model.Filter.SearchTerm.toLocaleLowerCase();
    const eventName = event.Name.toLocaleLowerCase();
    if (((eventName.indexOf(searchTerm) >= 0) && (!model.Filter.ShowOnlyEligible ? true : isEligible)) && ((model.Filter.ShowOnlyFromLevels.length === 0) ? true : isInLevelsToShow)) {
        if (model.Filter.ShowOnlyOfCourses.length === 0) {
            return true;
        }
        else {
            return isOneOfCoursesToShow;
        }
    }
    else {
        return false;
    }
}

function Promises_fetchEvents(isAdmin, dispatch) {
    const pr = startAsPromise(singleton.Delay(() => singleton.TryFinally(singleton.Delay(() => singleton.Bind(isAdmin ? Event$_1.GetAll() : Event$_1.GetEnabled(), (_arg) => {
        dispatch(new Msg(0, [Result_ToOption(_arg)]));
        return singleton.Zero();
    })), () => {
        dispatch(new Msg(3, [false]));
    })));
    void pr;
}

function Promises_fetchTracks(isAdmin, dispatch) {
    const pr = startAsPromise(isAdmin ? Track.GetAll() : Track.GetAllEnabled());
    void (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(1, [res.fields[0]]));
        }
    }));
}

function Promises_fetchCourses(dispatch) {
    const pr = startAsPromise(Course.GetAllCourses());
    void (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(2, [res.fields[0]]));
        }
    }));
}

function Promises_fetchUserCompletedTasks(dispatch) {
    const pr = startAsPromise(Task.GetMy());
    void (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(4, [res.fields[0]]));
        }
    }));
}

function Promises_fetchEventsUserAttends(dispatch) {
    const pr = startAsPromise(Event$_1.GetMy());
    void (pr.then((res) => {
        if (res.tag === 1) {
        }
        else {
            dispatch(new Msg(5, [res.fields[0]]));
        }
    }));
}

function Promises_signUp(event, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.SignUp(event.Id));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            errorToast(setCtx, `signUpError${event.Id}`, "Kunne ikke melde på", `Kunne ikke finne ${event.Name}`, undefined);
        }
        else {
            dispatch(new Msg(7, [event.Id]));
            successToast(setCtx, `signUpEvent${event.Id}Success`, "Påmeldt", `Du ble meldt på ${event.Name}`);
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function Promises_withdraw(eventId, model, dispatch, setCtx) {
    let pr_1;
    const pr = startAsPromise(Event$_1.Withdraw(eventId));
    pr_1 = (pr.then((res) => {
        if (res.tag === 1) {
            switch (res.fields[0].tag) {
                case 2: {
                    dispatch(new Msg(5, [model.EventsUserAttends.filter((event) => (event.Id !== eventId))]));
                    break;
                }
                case 1: {
                    errorToast(setCtx, "withdrawUserNotFound", "Kunne ikke melde av", "Noe gikk galt", undefined);
                    break;
                }
                default:
                    errorToast(setCtx, "withdrawEventNotFound", "Kunne ikke melde av", "Kunne ikke finne kurs å melde av", undefined);
            }
        }
        else {
            dispatch(new Msg(8, [eventId]));
            successToast(setCtx, "withdrawEventSuccess", "Avmeldt", "Du ble meldt av kurset");
        }
    }));
    void (pr_1.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
}

function EventCard(eventCardInputProps) {
    let elems_16, elems_12, elems_9, elems_2, elems_8, elems_3, el_12, el_14, elems_4, el_16, el_18, locale, formatOptions, elems_5, el_20, el_22, locale_1, formatOptions_1, elems_6, el_24, el_26, elems_7, elems_11, el_40, elems_10, el_38, el_36, el_54, elems_15;
    const model = eventCardInputProps.model;
    const event = eventCardInputProps.event;
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const userIsAttending = model.EventsUserAttends.some((event$0027) => (event$0027.Id === event.Id));
    const userHasTaken = event.Course.Tasks.every((task) => contains(task, model.UserCompletedTasks, {
        Equals: equals,
        GetHashCode: safeHash,
    }));
    const trackAndLevel = tryPick((track) => map((level_1) => [track, level_1], tryFind((level) => level.TrackLevelCourses.some((tlc) => (tlc.Course.Id === event.Course.Id)), track.TrackLevels)), model.AllTracks);
    const userIsEligible = defaultArg(map((tupledArg) => tupledArg[1].RequiredTasks.every((requiredTask) => contains(requiredTask, model.UserCompletedTasks, {
        Equals: equals,
        GetHashCode: safeHash,
    })), trackAndLevel), true);
    const el_56 = Card;
    return createElement(el_56, createObj(ofArray([["style", {
        display: "flex",
        padding: 0,
        gap: 0 + "px ",
    }], (elems_16 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexGrow: 1,
        flexWrap: "wrap",
        justifyContent: "space-between",
        padding: 15,
    }], (elems_12 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 20 + "px ",
        flexDirection: "column",
        justifyContent: "space-between",
    }], (elems_9 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        gap: 15 + "px ",
        alignItems: "center",
    }], (elems_2 = toList(delay(() => {
        let el;
        return append_1(singleton_1((el = Subtitle1, createElement(el, {
            children: event.Name,
        }))), delay(() => {
            let el_2;
            return append_1(singleton_1((el_2 = Badge, createElement(el_2, {
                children: event.Course.Name,
            }))), delay(() => {
                let elems, el_4, el_6, elems_1, el_8, el_10;
                return userIsAttending ? singleton_1(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    gap: 5 + "px ",
                    alignItems: "center",
                }], (elems = [(el_4 = CheckboxCheckedRegular, createElement(el_4, {})), (el_6 = Caption1, createElement(el_6, {
                    children: "Du er påmeldt",
                }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))) : (userHasTaken ? singleton_1(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    gap: 5 + "px ",
                    alignItems: "center",
                }], (elems_1 = [(el_8 = CheckboxCheckedRegular, createElement(el_8, {})), (el_10 = Caption1, createElement(el_10, {
                    children: "Du har allerede tatt dette kurset",
                }))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))) : empty());
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        gap: 20 + "px ",
        flexWrap: "wrap",
    }], (elems_8 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_3 = [(el_12 = PersonAccountsRegular, createElement(el_12, {
        fontSize: 24,
        primaryFill: tokens.colorBrandBackground,
    })), (el_14 = Label, createElement(el_14, {
        size: "medium",
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `${event.Teacher.FirstName} ${event.Teacher.LastName}`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_4 = [(el_16 = CalendarDateRegular, createElement(el_16, {
        fontSize: 24,
        primaryFill: tokens.colorBrandBackground,
    })), (el_18 = Label, createElement(el_18, {
        size: "medium",
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `${(locale = nb, (formatOptions = {}, (formatOptions.locale = locale, format_2(event.Time, "dd MMM yy", formatOptions))))}`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_5 = [(el_20 = ClockRegular, createElement(el_20, {
        fontSize: 24,
        primaryFill: tokens.colorBrandBackground,
    })), (el_22 = Label, createElement(el_22, {
        size: "medium",
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `${(locale_1 = nb, (formatOptions_1 = {}, (formatOptions_1.locale = locale_1, format_2(event.Time, "HH:mm", formatOptions_1))))}`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_5))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_6 = [(el_24 = PeopleQueueRegular, createElement(el_24, {
        fontSize: 24,
        primaryFill: tokens.colorBrandBackground,
    })), (el_26 = Label, createElement(el_26, {
        size: "medium",
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: `${event.AttendeeCount}/${event.MaxAttendees}`,
    }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        alignItems: "center",
        gap: 5 + "px ",
    }], (elems_7 = toList(delay(() => {
        let el_28;
        return append_1(singleton_1((el_28 = LocationRegular, createElement(el_28, {
            fontSize: 24,
            primaryFill: tokens.colorBrandBackground,
        }))), delay(() => {
            let el_30;
            return append_1(singleton_1((el_30 = Label, createElement(el_30, {
                size: "medium",
                style: {
                    color: tokens.colorNeutralForeground3,
                },
                children: event.Address,
            }))), delay(() => {
                let el_34, el_32;
                return !event.Enabled ? singleton_1((el_34 = Badge, createElement(el_34, {
                    style: {
                        marginLeft: 10,
                    },
                    appearance: "tint",
                    color: "warning",
                    size: "large",
                    children: (el_32 = Caption2, createElement(el_32, {
                        children: "Utkast",
                    })),
                }))) : empty();
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))], ["children", reactApi.Children.toArray(Array.from(elems_9))])]))), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton_1(["display", "flex"]), delay(() => append_1(singleton_1(["flexDirection", "column"]), delay(() => append_1(singleton_1(["justifyContent", "center"]), delay(() => append_1(isMobile ? append_1(singleton_1(["flexGrow", 1]), delay(() => singleton_1(["paddingTop", 15]))) : empty(), delay(() => singleton_1(["minHeight", 100 + "%"]))))))))))))], (elems_11 = [(el_40 = Link, createElement(el_40, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["kurs", int32ToString(event.Id)]), 1)], (elems_10 = [(el_38 = Button, createElement(el_38, {
        style: {
            width: 100 + "%",
        },
        icon: (el_36 = ArrowRightRegular, createElement(el_36, {})),
        iconPosition: "after",
        children: "Åpne",
    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_10))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))], ["children", reactApi.Children.toArray(Array.from(elems_12))])]))), (el_54 = CardFooter, createElement(el_54, createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "space-between",
        borderTop: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke1,
        padding: 15,
        alignItems: "center",
    }], (elems_15 = toList(delay(() => {
        let el_46, elems_13, el_44, el_42;
        if (trackAndLevel != null) {
            const track_1 = trackAndLevel[0];
            const level_3 = trackAndLevel[1];
            return append_1(singleton_1((el_46 = Link, createElement(el_46, createObj(ofArray([["href", RouterModule_encodeParts(ofArray(["kurslop", int32ToString(track_1.Id)]), 1)], ["style", {
                textDecorationLine: "none",
            }], (elems_13 = [(el_44 = Button, createElement(el_44, {
                appearance: "subtle",
                size: "small",
                style: {
                    paddingLeft: 0,
                    display: "flex",
                    alignItems: "center",
                    gap: 5 + "px ",
                },
                icon: (el_42 = LayerDiagonalPersonRegular, createElement(el_42, {
                    fontSize: 24,
                    primaryFill: tokens.colorBrandBackground,
                })),
                children: track_1.Name,
            }))], ["children", reactApi_1.Children.toArray(Array.from(elems_13))])]))))), delay(() => {
                let elems_14;
                return singleton_1(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append_1(singleton_1(["display", "flex"]), delay(() => append_1(singleton_1(["alignItems", "center"]), delay(() => (isMobile ? append_1(singleton_1(["flexDirection", "column-reverse"]), delay(() => singleton_1(["gap", 5 + "px "]))) : append_1(singleton_1(["flexDirection", "row"]), delay(() => singleton_1(["gap", 15 + "px "])))))))))))], (elems_14 = toList(delay(() => {
                    let el_48;
                    return append_1(!userIsEligible ? singleton_1((el_48 = Caption1, createElement(el_48, {
                        children: "Du har ikke tilgang til dette nivået",
                    }))) : empty(), delay(() => {
                        let el_52;
                        return singleton_1((el_52 = Badge, createElement(el_52, createObj(toList(delay(() => {
                            let el_50;
                            return append_1(singleton_1(["icon", (el_50 = LayerRegular, createElement(el_50, {}))]), delay(() => append_1(singleton_1(["children", level_3.Name]), delay(() => append_1(singleton_1(["appearance", "tint"]), delay(() => (userIsEligible ? singleton_1(["color", "success"]) : singleton_1(["color", "danger"]))))))));
                        }))))));
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_14))])]))));
            }));
        }
        else {
            return singleton_1(createElement("div", {
                style: {
                    height: 24,
                },
            }));
        }
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_15))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_16))])])));
}

function FilterPopover(filterPopoverInputProps) {
    let elems_4, el_4, el_2, el, el_22, elems_3, elems_1, el_16, elems_2, elemsToUse;
    const dispatch = filterPopoverInputProps.dispatch;
    const model = filterPopoverInputProps.model;
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const el_24 = Popover;
    return createElement(el_24, createObj(ofArray([["trapFocus", true], ["positioning", {
        position: "below",
        align: "start",
    }], (elems_4 = [(el_4 = PopoverTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            icon: (el = FilterRegular, createElement(el, {})),
            iconPosition: "before",
            children: "Filter",
        })),
    })), (el_22 = PopoverSurface, createElement(el_22, createObj(ofArray([["style", createObj(toList(delay(() => append_1(isMobile ? singleton_1(["minWidth", 90 + "vw"]) : singleton_1(["minWidth", 500]), delay(() => append_1(singleton_1(["display", "flex"]), delay(() => singleton_1(["flexDirection", "row"]))))))))], (elems_3 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 5 + "px ",
        minWidth: 45 + "%",
    }], (elems_1 = toList(delay(() => {
        let el_6;
        return append_1(singleton_1((el_6 = Body1Strong, createElement(el_6, {
            children: "Din status",
        }))), delay(() => {
            let el_8;
            return append_1(singleton_1((el_8 = Checkbox, createElement(el_8, {
                label: "Kurs du kan ta",
                checked: model.Filter.ShowOnlyEligible,
                onChange: (_arg, c) => {
                    let bind$0040;
                    dispatch(new Msg(6, [(bind$0040 = model.Filter, new Filter(bind$0040.SearchTerm, Checkbox_toBool(c), bind$0040.ShowOnlyFromLevels, bind$0040.ShowOnlyOfCourses))]));
                },
            }))), delay(() => {
                let el_10;
                return append_1(singleton_1((el_10 = Divider, createElement(el_10, {
                    children: "Kursløp",
                }))), delay(() => map_1((track) => {
                    let elems;
                    return createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                    }], (elems = toList(delay(() => {
                        let el_12;
                        return append_1(singleton_1((el_12 = Body1Strong, createElement(el_12, {
                            children: track.Name,
                        }))), delay(() => map_1((level) => {
                            const el_14 = Checkbox;
                            return createElement(el_14, {
                                label: level.Name,
                                checked: contains(level, model.Filter.ShowOnlyFromLevels, {
                                    Equals: equals,
                                    GetHashCode: safeHash,
                                }),
                                onChange: (_arg_1, c_1) => {
                                    let bind$0040_1;
                                    dispatch(new Msg(6, [(bind$0040_1 = model.Filter, new Filter(bind$0040_1.SearchTerm, bind$0040_1.ShowOnlyEligible, Checkbox_toBool(c_1) ? append([level], model.Filter.ShowOnlyFromLevels) : model.Filter.ShowOnlyFromLevels.filter((level$0027) => !equals(level$0027, level)), bind$0040_1.ShowOnlyOfCourses))]));
                                },
                            });
                        }, track.TrackLevels)));
                    })), ["children", reactApi.Children.toArray(Array.from(elems))])])));
                }, model.AllTracks)));
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))), (el_16 = Divider, createElement(el_16, {
        vertical: true,
    })), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 5 + "px ",
        minWidth: 45 + "%",
    }], (elems_2 = toList(delay(() => {
        let el_18;
        return append_1(singleton_1((el_18 = Body1Strong, createElement(el_18, {
            children: "Kurstype",
        }))), delay(() => map_1((course) => {
            const el_20 = Checkbox;
            return createElement(el_20, {
                label: course.Name,
                checked: contains(course.Id, model.Filter.ShowOnlyOfCourses, {
                    Equals: (x_1, y_1) => (x_1 === y_1),
                    GetHashCode: numberHash,
                }),
                onChange: (_arg_2, c_2) => {
                    let bind$0040_2;
                    dispatch(new Msg(6, [(bind$0040_2 = model.Filter, new Filter(bind$0040_2.SearchTerm, bind$0040_2.ShowOnlyEligible, bind$0040_2.ShowOnlyFromLevels, Checkbox_toBool(c_2) ? append(new Int32Array([course.Id]), model.Filter.ShowOnlyOfCourses, Int32Array) : model.Filter.ShowOnlyOfCourses.filter((courseId) => (courseId !== course.Id))))]));
                },
            });
        }, model.AllCourses)));
    })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])]))))], (elemsToUse = ((length(elems_4) <= 2) ? elems_4 : take(2, elems_4)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

export function View() {
    let elems_10;
    const ctx = useCtx()[0];
    let patternInput_1;
    const arg_1 = init();
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    useEffectOnce(() => {
        Promises_fetchEvents(ctx.User.IsAdmin, dispatch);
        Promises_fetchTracks(ctx.User.IsAdmin, dispatch);
        Promises_fetchCourses(dispatch);
        Promises_fetchUserCompletedTasks(dispatch);
        Promises_fetchEventsUserAttends(dispatch);
    });
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 2 + "rem",
    }], (elems_10 = toList(delay(() => {
        let elems_1;
        return append_1(singleton_1(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
        }], (elems_1 = toList(delay(() => {
            let elems, el, el_2;
            return append_1(singleton_1(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
            }], (elems = [(el = Title3, createElement(el, {
                children: "Tilgjengelige Kurs",
            })), (el_2 = Caption1, createElement(el_2, {
                children: "Bla gjennom og meld deg på kurs",
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => (ctx.User.IsAdmin ? singleton_1(createElement(Dialog, {
                appendEvent: (event) => {
                    iterate((events) => {
                        dispatch(new Msg(0, [sortBy((_arg_1) => _arg_1.Time, append([event], events), {
                            Compare: compare,
                        })]));
                        dispatch(new Msg(6, [Filter_Empty()]));
                    }, toArray(model_1.Events));
                },
            })) : empty())));
        })), ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let el_15, elems_4, el_6, el_4, elems_3, el_13, matchValue, el_10, el_8;
            return append_1(singleton_1((el_15 = Card, createElement(el_15, createObj(ofArray([["orientation", "horizontal"], ["style", {
                width: 100 + "%",
                display: "flex",
                justifyContent: "space-between",
            }], (elems_4 = [(el_6 = Input, createElement(el_6, {
                contentBefore: (el_4 = SearchRegular, createElement(el_4, {})),
                placeholder: "Søk etter kurs...",
                value: model_1.Filter.SearchTerm,
                onChange: (_arg_2, value_1_4) => {
                    let bind$0040;
                    const v = value_1_4;
                    dispatch(new Msg(6, [(bind$0040 = model_1.Filter, new Filter(isNullOrWhiteSpace(v.value) ? "" : v.value, bind$0040.ShowOnlyEligible, bind$0040.ShowOnlyFromLevels, bind$0040.ShowOnlyOfCourses))]));
                },
            })), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                gap: 5 + "px ",
            }], (elems_3 = [createElement(FilterPopover, {
                model: model_1,
                dispatch: dispatch,
            }), (el_13 = Tooltip, createElement(el_13, createObj(ofArray([["content", "Tilbakestill"], (matchValue = tryHead([(el_10 = Button, createElement(el_10, {
                icon: (el_8 = ArrowResetRegular, createElement(el_8, {})),
                onClick: (_arg_3) => {
                    dispatch(new Msg(6, [Filter_Empty()]));
                },
                disabled: equals(model_1.Filter, Filter_Empty()),
            }))]), (matchValue == null) ? ["children", defaultOf()] : ["children", matchValue])]))))], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))), delay(() => {
                let elems_6, el_27, el_29, elems_9, el_25, elems_5, el_17, el_19, el_21, el_23;
                const matchValue_1 = model_1.Events;
                if (matchValue_1 != null) {
                    const events_1 = matchValue_1;
                    return (events_1.length === 0) ? singleton_1(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                    }], (elems_6 = [(el_27 = WeatherSunnyLowRegular, createElement(el_27, {
                        primaryFill: tokens.colorBrandForeground1,
                        style: {
                            fontSize: 96 + "px",
                        },
                    })), (el_29 = Caption1, createElement(el_29, {
                        children: "Det finnes ingen kurs som er relevante for deg akkurat nå",
                    }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])])))) : singleton_1(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "column",
                        gap: 15 + "px ",
                    }], (elems_9 = toList(delay(() => {
                        const filteredEvents = events_1.filter((event_1) => applyFilter(model_1, event_1));
                        return append_1(map_1((event_2) => createElement(EventCard, {
                            event: event_2,
                            model: model_1,
                        }), filteredEvents), delay(() => {
                            let elems_8, el_31, elems_7, el_33, el_37, el_35;
                            return (!equals(model_1.Filter, Filter_Empty()) && (events_1.length > filteredEvents.length)) ? singleton_1(createElement("div", createObj(ofArray([["style", {
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: 15 + "px ",
                            }], (elems_8 = [(el_31 = FilterRegular, createElement(el_31, {
                                fontSize: 48,
                                primaryFill: tokens.colorNeutralStroke1,
                            })), createElement("div", createObj(ofArray([["style", {
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "center",
                                gap: 5 + "px ",
                            }], (elems_7 = [(el_33 = Caption1, createElement(el_33, {
                                children: `${events_1.length - filteredEvents.length} kurs er filtrert bort`,
                            })), (el_37 = Button, createElement(el_37, {
                                icon: (el_35 = ArrowResetRegular, createElement(el_35, {})),
                                size: "small",
                                children: "Tilbakestill filter",
                                onClick: (_arg_4) => {
                                    dispatch(new Msg(6, [Filter_Empty()]));
                                },
                            }))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])))], ["children", reactApi.Children.toArray(Array.from(elems_8))])])))) : empty();
                        }));
                    })), ["children", reactApi.Children.toArray(Array.from(elems_9))])]))));
                }
                else {
                    return model_1.IsFetchingEvents ? singleton_1((el_25 = Skeleton, createElement(el_25, createObj(ofArray([["style", {
                        width: 100 + "%",
                        display: "flex",
                        flexDirection: "column",
                        gap: 10 + "px ",
                    }], (elems_5 = [(el_17 = SkeletonItem, createElement(el_17, {
                        style: {
                            height: 8 + "vh",
                        },
                        animation: "wave",
                        shape: "rectangle",
                    })), (el_19 = SkeletonItem, createElement(el_19, {
                        style: {
                            height: 8 + "vh",
                        },
                        animation: "wave",
                        shape: "rectangle",
                    })), (el_21 = SkeletonItem, createElement(el_21, {
                        style: {
                            height: 8 + "vh",
                        },
                        animation: "wave",
                        shape: "rectangle",
                    })), (el_23 = SkeletonItem, createElement(el_23, {
                        style: {
                            height: 8 + "vh",
                        },
                        animation: "wave",
                        shape: "rectangle",
                    }))], ["children", reactApi_1.Children.toArray(Array.from(elems_5))])]))))) : singleton_1(dataFetchFailedView());
                }
            }));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_10))])])));
}

//# sourceMappingURL=ListEvents.jsx.map
